var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10671 7.24665C8.04004 7.23998 7.96004 7.23998 7.88671 7.24665C6.30004 7.19332 5.04004 5.89332 5.04004 4.29332C5.04004 2.65998 6.36004 1.33331 8.00004 1.33331C9.63337 1.33331 10.96 2.65998 10.96 4.29332C10.9534 5.89332 9.69337 7.19332 8.10671 7.24665Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77329 9.70669C3.15996 10.7867 3.15996 12.5467 4.77329 13.62C6.60663 14.8467 9.61329 14.8467 11.4466 13.62C13.06 12.54 13.06 10.78 11.4466 9.70669C9.61996 8.48669 6.61329 8.48669 4.77329 9.70669Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.555d7344d4f1d1067638bf84515e5bd0.svg";
export { ForwardRef as ReactComponent };